export interface Notifications {
  type: string;
  value: string;
  timeout: number;
  time?: Date;
  icon?: string;
  quiet?: boolean;
  uid?: any;
  loaderValue?: number;
}

export default {
  state: {
    notifications: [],
    visible_notifications: []
  },
  getters: {
    notifications(state: any) {
      return state.notifications;
    },
    visible_notifications(state: any) {
      return state.visible_notifications;
    }
  },
  mutations: {
    SET_NOTIFICATION(state: any, value: Notifications) {
      value.time = new Date();
      state.notifications.unshift(value);
    },
    REMOVE_NOTIFICATION(state: any, value: Notifications) {
      state.notifications = state.notifications.filter((val: Notifications) => {
        return val.value !== value.value;
      });
    },
    SET_VISIBLE_NOTIFICATION(state: any, value: Notifications) {
      state.visible_notifications.push(value);
    },
    REMOVE_VISIBLE_NOTIFICATION(state: any, value: Notifications) {
      if (
        value &&
        state.visible_notifications &&
        state.visible_notifications.length > 0 &&
        state.visible_notifications[0].value == value.value
      ) {
        state.visible_notifications.shift(value);
      }
    },
    UPDATE_VISIBLE_NOTIFICATION(state: any, val: any) {
      state.notifications.forEach((ele: Notifications, idx: number) => {
        if (ele.uid && ele.uid == val.uid) {
          Object.keys(val).forEach(key => {
            state.notifications[idx][key] = val[key];
          });
          return;
        }
      });
    }
  },
  actions: {
    addNotification({ commit }: any, val: Notifications) {
      commit("SET_NOTIFICATION", val);
      if (!val.quiet) {
        commit("SET_VISIBLE_NOTIFICATION", val);
      }
    },
    removeVisibleNotification({ commit }: any, val: Notifications) {
      commit("REMOVE_VISIBLE_NOTIFICATION", val);
    },
    updateVisibleNotification({ commit }: any, val: any) {
      commit("UPDATE_VISIBLE_NOTIFICATION", val);
    }
  }
};
